module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-title-pc@2x_51d1ba7a2b2300429373b77c40e6760a.png";